/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRecoilState } from 'recoil';
import { faChartNetwork, faRectangleHistory } from '@fortawesome/pro-solid-svg-icons';
import { faFileDownload, faFilePdf } from '@fortawesome/pro-regular-svg-icons';
import { Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { _SidebarApplicationData } from '../_Recoil/atoms';
import MenuCard from '../_GlobalComponents/MenuCard';


const Payroll = (props) => {
  const [sidebarAppData, setSidebarAppData] = useRecoilState(_SidebarApplicationData);
  const history = useHistory();

  useEffect(() => {
    setSidebarAppData([
      {
        href: '/Payroll/MassMutual', // link to location
        icon: faFilePdf, // icon, from font awesome
        title: '401K Mass Mutual', // label
        dock: true, // true if want to appear on the bottom navigation bar on mobile
      }
    ]);
  }, []);

  const Apps = [
    {
      label: '401K Mass Mutual',
      description: 'Download Files to Upload to 401K Provider',
      icon: faFilePdf,
      link: '/Payroll/MassMutual'
    }
  ];
  return (
    <Grid container>
      {Apps.map(app => <Grid key={app.label} item xs={12} sm={6} lg={4} xl={3}>
        <MenuCard label={app.label} icon={app.icon} description={app.description} link={app.link} history={history} />
      </Grid>)}
    </Grid>
  );

};


Payroll.propTypes = {};
Payroll.defaultProps = {};


export default Payroll;